// Core
import { Component } from '@angular/core';

// Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";

@Component({
    standalone: true,
    selector: 'app-index-about-section',
    imports: [FontAwesomeModule],
    templateUrl: './index-about-section.html',
    styleUrl: './index-about-section.scss',
})
export class IndexAboutSection {

    faArrowUp = faArrowUp;
    faArrowDown = faArrowDown;
}
